import {Component, Input, OnInit} from '@angular/core';
import {MasterSchedulePreferences} from '../../master-schedule-preferences.model';
import {PeriodStatisticsPreferences} from '../../period-statistics-preferences.model';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {ScheduleStudentListPreferences} from '../../schedule-student-list-preferences.model';
import {ClassesByCoursePreferences} from '../../classes-by-course-preferences.model';
import {ClassRosterPreferences} from '../../class-roster-preferences.model';
import {RoomSchedulingSettingsPreferences} from '../../room-scheduling-settings-preferences.model';

@Component({
    selector: 'scheduling-tab',
    templateUrl: './scheduling-tab.component.html',
    styleUrls: [
        './scheduling-tab.component.css',
        '../user-preferences-window.component.css'
    ]
})
export class SchedulingTabComponent implements OnInit {

    // Input Properties
    @Input() masterSchedulePreferences: MasterSchedulePreferences;
    @Input() periodStatisticsPreferences: PeriodStatisticsPreferences;
    @Input() scheduleStudentListPreferences: ScheduleStudentListPreferences;
    @Input() classesByCoursePreferences: ClassesByCoursePreferences;
    @Input() classRosterPreferences: ClassRosterPreferences;
    @Input() roomSchedulingSettingsPreferences: RoomSchedulingSettingsPreferences;
    @Input() canSeeMasterSchedule: boolean;
    @Input() canSeePeriodStatistics: boolean;
    @Input() canSeeScheduleStudentList: boolean;
    @Input() canSeeClassesByCourse: boolean;
    @Input() canSeeRoomSchedulingSettings: boolean;
    @Input() fieldDrop = (event: CdkDragDrop<string[]>) => {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        else {
            transferArrayItem(event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex);
        }
    }

    constructor() { }

    ngOnInit() {
    }

}
